/**
 * 「一级页面 / 二级页面」的登记处 —— 全站只有这一份口径。
 *
 * 2026-09-20 需求：未登录用户**一级页面都能看**，进**二级页面才要求登录**。
 * 规则如果散落在各个页面里各写一遍，迟早会漂移（有的页面放了、有的没放），
 * 所以集中到这一个数组里，路由守卫（router/index.js）和接口层（utils/http.js）
 * 都从这里读，保证「能进的页面」和「进了不会被接口踢走的页面」是同一批。
 *
 * 判断标准（照这个标准维护，别凭感觉加）：
 *   一级页面 = 底部导航 / 顶部导航能直接点到，或者是公示性质的内容
 *              （协议、联系我们）。未登录可浏览，价格类敏感信息用 ** 打码。
 *   二级页面 = 从一级页面点进去、且要动用个人数据或产生交易行为的页面，
 *              一律不登记在这里 → 未登录访问自动跳登录页。
 *
 * ⚠️ 新增一个「未登录也要能看」的页面，把它的 path 加到下面数组里即可，
 *    别再去改 router/index.js 或 http.js 的判断逻辑。
 */
const PUBLIC_PAGES = [
  "/", // 首页
  "/home",
  "/logIn", // 登录页本身，必须放行，否则会死循环跳转
  "/404",
  "/zhaoshang", // 产业招商
  "/VIP", // 会员福利（底部导航入口）
  "/VIPEquities", // 会员权益（套餐列表，未登录展示全部、价格打码）
  "/advancedSearch", // 高级搜索
  "/shuziYuanqu", // 数字园区
  "/agreement", // 会员协议（公示内容，未登录也该能看）
  "/contactUs", // 联系我们（公示内容）
  // 个人中心是底部导航的一级入口，而且 2026-09-16 专门做过未登录态
  // （头像旁「去登录」+ 标语 + 注册时间不留空），所以列为一级页面。
  // 它下面的「常用功能」8 个入口（我的订单 / 我的关注 / 发票管理 …）都是二级，
  // 未登录点了会被路由守卫送到登录页 —— 正符合「一级可看、二级要登录」。
  "/personalCenter",
];

/**
 * 判断某个路径是不是「一级页面」（未登录可访问）。
 * 兼容带 query / hash 的写法（如 /VIPEquities?from=1）。
 */
export function isPublicPage(path) {
  const p = String(path || "").split("?")[0].split("#")[0];
  // 末尾斜杠归一化：/zhaoshang/ 与 /zhaoshang 视为同一个
  const norm = p.length > 1 ? p.replace(/\/+$/, "") : p;
  return PUBLIC_PAGES.includes(norm);
}

export { PUBLIC_PAGES };
export default isPublicPage;
